
<div class="h-100 w-100 m-0 row bg-custom-primary">
    <div class="col-md-7 form-container px-4 py-3">
        <div class="d-flex justify-content-between">
            <div class="logo">
                <img [src]="cvaUI_url+ '/assets/images/logo.svg'" alt="logo" width="70px">
            </div>
        </div>
        <div class="h-100 row align-items-center" *ngIf="!processing">
            <div class="col offset-md-2">
                <h2>
                    Your account is mapped to multiple facilities. Please choose a facility to log in to,
                </h2>
                <form [formGroup]="facilitySelectionForm" (ngSubmit)="selectFacilityId()">
                    <mat-radio-group aria-labelledby="facility code radio group" formControlName="activeFacility" class="d-flex flex-column">
                        @for (facility of availableFacilities; track facility) {
                            <mat-radio-button color="primary" [value]="facility">{{facility.id + (facility.name ? " - " + facility.name : "" )}}</mat-radio-button>
                        }
                    </mat-radio-group>
                    <div class="form-actions mt-3">
                        <button type="submit" class="btn btn-dark">Select & Continue</button>
                      </div>
                </form>
            </div>
        </div>
    </div>
    <div class="h-100 col-md-5 bg-cover position-relative bg-co d-none d-md-block">
        <cva-form-template></cva-form-template>
    </div>
</div>